var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{},[_c('app-page-top-section',{attrs:{"title":_vm.$t('Log Report'),"icon":"briefcase"}})],1),_vm._v(" "),(_vm.options.url)?_c('app-table',{attrs:{"id":_vm.table_id,"options":_vm.options},on:{"action":_vm.triggerActions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }